import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* getGameAttributes(action) {
    try {
        try {
            const gameFeatures = yield call(() =>
                gamesAPI.getGameFeatures(action.payload.client)
            );

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_SUCCESS,
                payload: {
                    data: gameFeatures.data,
                    client: action.payload.client
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting game features.");

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_FAIL,
                message: e.message
            });
        }

        try {
            const gameSeries = yield call(() =>
                gamesAPI.getGameSeries(action.payload.client)
            );

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_SUCCESS,
                payload: {
                    data: gameSeries.data,
                    client: action.payload.client
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting game series.");

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_FAIL,
                message: e.message
            });
        }

        try {
            const gamePlatforms = yield call(() =>
                gamesAPI.getGamePlatforms(action.payload.client)
            );

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_SUCCESS,
                payload: {
                    data: gamePlatforms.data,
                    client: action.payload.client
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting game platforms.");

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_FAIL,
                message: e.message
            });
        }

        try {
            const gameTypes = yield call(() =>
                gamesAPI.getGameTypes(action.payload.client)
            );

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_SUCCESS,
                payload: { data: gameTypes.data, client: action.payload.client }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting game types.");

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_FAIL,
                message: e.message
            });
        }

        try {
            const gameTrademarks = yield call(() =>
                gamesAPI.getGameTrademarks(action.payload.client)
            );

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_SUCCESS,
                payload: {
                    data: gameTrademarks.data,
                    client: action.payload.client
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting game trdemarks.");

            yield put({
                type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_FAIL,
                message: e.message
            });
        }

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_SUCCESS
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game attributes.");

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_FAIL,
            message: e.message
        });
    }
}

export function* getGameAttributesWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME_ATTRIBUTES, getGameAttributes);
}

function* getClients(action) {
    try {
        const clients = yield call(() => gamesAPI.getClients());

        yield put({
            type: GamesActionTypes.GET_CLIENTS_SUCCESS,
            payload: {
                data: clients.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting clients list.");

        yield put({
            type: GamesActionTypes.GET_CLIENTS_FAIL,
            message: e.message
        });
    }
}

export function* getClientsWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME_ATTRIBUTES, getClients);
}

function* getFeatures(action) {
    try {
        const gameFeatures = yield call(() =>
            gamesAPI.getGameFeatures(action.payload.client)
        );

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_SUCCESS,
            payload: {
                data: gameFeatures.data,
                client: action.payload.client
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game features.");

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_FAIL,
            message: e.message
        });
    }
}

export function* getGameFeaturesWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES,
        getFeatures
    );
}

function* getSeries(action) {
    try {
        const gameSeries = yield call(() =>
            gamesAPI.getGameSeries(action.payload.client)
        );

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_SUCCESS,
            payload: {
                data: gameSeries.data,
                client: action.payload.client
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game series.");

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_FAIL,
            message: e.message
        });
    }
}

export function* getGameSeriesWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES, getSeries);
}

function* getPlatforms(action) {
    try {
        const gamePlatforms = yield call(() =>
            gamesAPI.getGamePlatforms(action.payload.client)
        );

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_SUCCESS,
            payload: {
                data: gamePlatforms.data,
                client: action.payload.client
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game platforms.");

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_FAIL,
            message: e.message
        });
    }
}

export function* getGamePlatformsWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM,
        getPlatforms
    );
}

function* getGameTypes(action) {
    try {
        const gameTypes = yield call(() =>
            gamesAPI.getGameTypes(action.payload.client)
        );

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_SUCCESS,
            payload: { data: gameTypes.data, client: action.payload.client }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game types.");

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_FAIL,
            message: e.message
        });
    }
}

export function* getGameTypesWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE, getGameTypes);
}

function* getGameTrademarks(action) {
    try {
        const gameTrademarks = yield call(() =>
            gamesAPI.getGameTrademarks(action.payload.client)
        );

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_SUCCESS,
            payload: {
                data: gameTrademarks.data,
                client: action.payload.client
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game trdemarks.");

        yield put({
            type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_FAIL,
            message: e.message
        });
    }
}

export function* getGameTrademarksWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS,
        getGameTrademarks
    );
}

function* editGameAttributes(action) {
    try {
        yield call(() =>
            gamesAPI.editGameAttribute(action.payload.values)
        );
        switch (action.payload.values.key) {
            case "series_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES,
                    payload: {client: action.payload.client}
                });
                break;
            case "trademark_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS,
                    payload: {client: action.payload.client}
                });
                break;
            case "feature_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES,
                    payload: {client: action.payload.client}
                });
                break;
            case "platform_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM,
                    payload: {client: action.payload.client}
                });
                break;
            case "type_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE,
                    payload: {client: action.payload.client}
                });
                break;
            default:
                return null
        }

        yield put({
            type: GamesActionTypes.EDIT_GAME_ATTRIBUTE_SUCCESS
        });
        ToasterService.successToast("Game attribute successfully edited");
    } catch (e) {
        API.handleError(e.response, "Error editing game attribute.");

        yield put({
            type: GamesActionTypes.EDIT_GAME_ATTRIBUTE_FAIL,
            message: e.message
        });
    }
}

export function* editGameAttributesWatcher() {
    yield takeLatest(
        GamesActionTypes.EDIT_GAME_ATTRIBUTE,
        editGameAttributes
    );
}

function* createGameAttributes(action) {
    try {
        yield call(() =>
            gamesAPI.createGameAttribute(action.payload.values)
        );
        switch (action.payload.values.key) {
            case "series_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES,
                    payload: { client: action.payload.client }
                });
                break;
            case "trademark_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS,
                    payload: { client: action.payload.client }
                });
                break;
            case "feature_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES,
                    payload: { client: action.payload.client }
                });
                break;
            case "platform_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM,
                    payload: { client: action.payload.client }
                });
                break;
            case "type_id":
                yield put({
                    type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE,
                    payload: { client: action.payload.client }
                });
                break;
            default:
                return null;
        }

        yield put({
            type: GamesActionTypes.CREATE_GAME_ATTRIBUTE_SUCCESS
        });
        ToasterService.successToast("Game attribute successfully created");
    } catch (e) {
        API.handleError(e.response, "Error adding game attribute.");

        yield put({
            type: GamesActionTypes.CREATE_GAME_ATTRIBUTE_FAIL,
            message: e.message
        });
    }
}

export function* createGameAttributesWatcher() {
    yield takeLatest(
        GamesActionTypes.CREATE_GAME_ATTRIBUTE,
        createGameAttributes
    );
}

function* getGameCreationAttributes(action) {
    try {
        const clients = yield call(() => gamesAPI.getClients());

        const gameFeatures = yield call(() => gamesAPI.getGameFeatures());

        const gameSeries = yield call(() => gamesAPI.getGameSeries());

        const gamePlatforms = yield call(() => gamesAPI.getGamePlatforms());

        const gameTypes = yield call(() => gamesAPI.getGameTypes());

        const gameTrademarks = yield call(() => gamesAPI.getGameTrademarks());

        yield put({
            type: GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES_SUCCESS,
            payload: {
                clients: clients.data,
                platforms: gamePlatforms.data,
                series: gameSeries.data,
                trademarks: gameTrademarks.data,
                features: gameFeatures.data,
                gameTypes: gameTypes.data
            }
        });
    } catch (e) {
        console.log(e);
        API.handleError(e.response, "Error getting game attributes.");

        yield put({
            type: GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES_FAIL,
            message: e.message
        });
    }
}

export function* getGameCreationAttributesWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES,
        getGameCreationAttributes
    );
}
